import { comments } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">吃瓜群众热议</h2>
          <p className="text-sm text-foreground-600">看看大家最近都在讨论什么瓜</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5">
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-medium text-sm text-foreground-900 whitespace-nowrap">{item.name}</span>
                    <span className="px-2 py-0.5 text-xs rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">{item.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i> {item.likes.toLocaleString()}
                </button>
                <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i> 回复
                </button>
                <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line"></i> 分享
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}